import React from "react"
import { Link } from "gatsby"
import "./LandingPageSchemeButton.css"

const LandingPageSchemeButton = ({ schemeButton, url }) =>
  <Link to={url} className="schemeButton">{schemeButton}</Link>

export default LandingPageSchemeButton